import React from 'react';
import { useIntl } from 'react-intl';

import { Box } from 'carbon-react/lib/components/box/box.component';
import Search, { SearchEvent } from 'carbon-react/lib/components/search';

import { ActiveMode } from '../../types';
import { ActionButtons } from '../action-buttons/action-buttons';
import * as styles from './search-with-actions.scss';

interface SearchWithActionsProps {
  isCOAEditable: boolean;
  activeMode?: ActiveMode;
  handleClose: () => void;
  handleSave: () => void;
  handleActionButtonClick: (mode: ActiveMode) => void;
  searchText: string;
  handleSearchChange: (event: SearchEvent) => void;
  navHeight: number;
  TABS_HEIGHT: number;
  isUpdatingStructure?: boolean;
}
export const SearchWithActions = ({
  isCOAEditable,
  activeMode,
  handleClose,
  handleSave,
  handleActionButtonClick,
  searchText,
  handleSearchChange,
  navHeight,
  TABS_HEIGHT,
  isUpdatingStructure
}: SearchWithActionsProps) => {
  const intl = useIntl();

  return (
    <div className={styles.actionsContainer} style={{ top: navHeight + TABS_HEIGHT }}>
      <Search
        id="search-accounts"
        className={styles.searchInput}
        label={intl.formatMessage({
          id: 'common.search_ellipsis',
          defaultMessage: 'Search...'
        })}
        onChange={handleSearchChange}
        value={searchText}
        inputWidth={100}
      />
      <Box alignSelf="stretch" mx="16px" backgroundColor="#CCD6DB" width="1px" />
      <ActionButtons
        isCOAEditable={isCOAEditable}
        activeMode={activeMode}
        handleClose={handleClose}
        handleSave={handleSave}
        handleInitialClick={handleActionButtonClick}
        isUpdatingStructure={isUpdatingStructure}
      />
    </div>
  );
};
